module.exports = ".image-wrapper {\n  width: 35px;\n  height: 35px;\n  margin-top: -6px;\n  margin-bottom: -6px; }\n  .image-wrapper .image {\n    width: 100%;\n    height: 100%;\n    background-size: cover !important;\n    background-position: 50% 50% !important; }\n  .image-wrapper:hover {\n    cursor: -webkit-zoom-in;\n    cursor: zoom-in; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/values/images/images.component.scss
// module id = ./libs/chassis-datatable/src/components/values/images/images.component.scss
// module chunks = main